import React, { useState, useContext, useEffect, useRef } from 'react'
import DictionaryContext from '../../../context/dictionaryContext'
import PatientContext from '../../../context/patientContext'
import UserPrefContext from '../../../context/userPrefContext'
import AuthContext from '../../../context/authContext'
import EarQListRow from './EarQListRow'

function EarQList(props) {

    const dictCtx = useContext(DictionaryContext)
    const visCtx = useContext(PatientContext)
    const userPrefCtx = useContext(UserPrefContext)
    const authCtx = useContext(AuthContext)
    
    const dict_intake_form_id = dictCtx.dict_intake_form.find(form => form.display_name_short === "earq").id 
    // const earQGetAllURL = `${process.env.REACT_APP_SERVER}/api/v1/form_responses/patient/${visCtx.pat_token}?dict_intake_form_id=${dict_intake_form_id}`
    const earQGetAllURL = `${process.env.REACT_APP_SERVER}/api/v1/form_responses/patient/${visCtx.pat_token}`

    const [earQs, setEarQs] = useState([])
    const [columnMapping, setColumnMapping] = useState([])


    const getAllEarQs = async() => {
        // console.log("EFaceList - getting all efaces")
        try {
            const response = await fetch(earQGetAllURL, {
                headers: {
                    'Authorization': `Bearer ${userPrefCtx.bearerToken}`,
                    auth: authCtx.authMode,
                },

            })

            if (response.status === 200) {
                const responseData = await response.json()
                // console.log("Get all aer-Qs", responseData)
                // sort them by earQ date
                setEarQs(responseData.filter(rd => rd.dict_intake_form_id = dict_intake_form_id).sort((a,b) => new Date(a.visit_date) > new Date(b.visit_date) ? 1 : -1))
            } else {
                console.log("Failed to get all Ear-Qs", response)
            }
        } catch (e) {
            console.log("Failed to get all Ear-Qs", e)
        }

    }


    useEffect(() => {
        // console.log("EFaceList - getting column mappings")
        // setColumnMapping(props.columnMapping)
        if (dictCtx.dict_table.length > 0) {
            // let headersMapping = dictCtx.dict_table.filter(entry => entry.group_display_name_short === 'earq')
            // debug!!!
            let headersMapping = [
              {
                column_name: "[[\"Action\", null], [\"Visit Date\", \"visit_date\"], [\"Updated on\",\"updated_at\"]]"
              }
            ]
            if (headersMapping.length > 0) {

            }
            setColumnMapping(JSON.parse(headersMapping[0].column_name))
        }
        
    }, [/*props.columnMapping*/ dictCtx.dict_table.length])

    useEffect(() => {
        // console.log("EarQList - props.updateDeleteCount", props.updateDeleteCount)
        if (userPrefCtx.bearerToken !== '' && props.updateDeleteCount >= 0) {
            getAllEarQs()
        }
        
    }, [userPrefCtx.bearerToken, props.updateDeleteCount])

    


    


    const onSelect = (earQ) => {
        props.onSelect(earQ)
    }

    return (
        <>
        <div>
            <table className="table table-sm table-borderless">
                <thead>
                    <tr>
                        {columnMapping.map((val, index) =>
                            <th scope="col" key={index} className='mx-4 px-10 text-left'>{val[0]}</th> 
                        )}
                    </tr>
                </thead>
                <tbody>
                    {earQs.map((eq, index) => 
                        <EarQListRow key={index} columnMapping={columnMapping} earQ={eq} onSelect={onSelect}/>
                    )}

                </tbody>
            </table>
            </div>
        </>
    )
}

export default EarQList